import { useState, useEffect } from 'react';

const getParamValue = (params, paramName) => {
  const variableKey = paramName;
  if (!params[variableKey]) throw Error(`Param ${paramName} was not provided`);
  return params[variableKey];
};
function generatePath(route, params, options) {
  const regex = /\[([a-zA-Z0-9_]+)\]/g;
  const res = route.toString().replace(regex, (_, key) => getParamValue(params, key));
  if (options?.withOrigin && typeof window !== "undefined") {
    return window.location.origin + res;
  }
  return res;
}
const getRouteParamAsString = (params, keys) => {
  return keys.map((key) => {
    const value = params[key];
    return typeof value === "string" ? value : null;
  });
};
const parseRouteSegments = (route) => {
  if (typeof window === "undefined") {
    return {};
  }
  const path = window.location.pathname;
  const routeParts = route.split("/");
  const pathParts = path.split("/");
  return routeParts.reduce((acc, part, index) => {
    if (part.startsWith("[")) {
      const key = part.replace(/\[|\]/g, "");
      acc[key] = pathParts[index];
    }
    return acc;
  }, {});
};
const useRouteSegments = (route) => {
  const [segments, setSegments] = useState(() => parseRouteSegments(route));
  useEffect(() => {
    const onPopState = () => {
      setSegments(parseRouteSegments(route));
    };
    window.addEventListener("popstate", onPopState);
  }, [route]);
  return segments;
};
const useOptionalCatchAllSegments = (route) => {
  const [segments, setSegments] = useState(() => parseOptionalCatchAllSegments(route));
  useEffect(() => {
    const onPopState = () => {
      setSegments(parseOptionalCatchAllSegments(route));
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [route]);
  return segments;
};
const parseOptionalCatchAllSegments = (route) => {
  if (typeof window === "undefined") {
    return [];
  }
  const path = window.location.pathname;
  const routeParts = route.split("/");
  const pathParts = path.split("/");
  const catchAllIndex = routeParts.findIndex((part) => part.startsWith("[[...") && part.endsWith("]]"));
  if (catchAllIndex === -1) {
    return [];
  }
  return pathParts.slice(catchAllIndex);
};

export { generatePath, getRouteParamAsString, useOptionalCatchAllSegments, useRouteSegments };
//# sourceMappingURL=routing.js.map
